import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';

import VisaSplash from '../assets/images/Visa Prepaid Cards - Splash.png';

import '../components/GlobalStyle.css';

import { CTA } from '../components/Layout/CTA';
import { FadeLoad, FadeScroll, FadeLoadDelay } from '../components/styled/Motion.styled';
import { PrepaidCardsTabs } from '../components/VisaPrepaidCardsComponents/PrepaidCardsTabs';
import { HoverCardBorder } from '../components/styled/BPSCards';



const VisaPrepaidCards = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Products & Services | Visa Prepaid Cards</title>
                <link rel="canonical" href="https://bestpayment.solutions/visa-prepaid-cards" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75 text-center' >
                <Row className='pt-5 justify-content-center align-items-center'>
                    <Col lg={7}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Visa Prepaid Cards</h2>
                            <h1 className='fs-48'>
                                Visa prepaid reward cards:
                                <br />
                                the ultimate incentive solution
                            </h1>
                        </FadeLoad>
                    </Col>
                    <Col lg={6} className='py-5'>
                        <FadeLoadDelay>
                            <img src={VisaSplash} width='100%' />
                        </FadeLoadDelay>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='py-5 bg-cream'>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={4}>
                        <h3 className='fs-48'>Versatility meets instant gratification</h3>
                        <p>
                            Whether you opt for our tangible physical Visa cards or our instantly accessible virtual Visa rewards, you're choosing a universally appreciated incentive. Designed for adaptability and accepted at over 44 million merchant locations worldwide, our prepaid Visa reward cards cater to both online enthusiasts and traditional shoppers, ensuring maximum engagement.
                        </p>
                    </Col>
                    <Col lg={4}>
                        <FadeScroll>
                            <HoverCardBorder className='my-3'>
                                <h5 className='fw-bold pt-4 fs-24'>The power of incentives</h5>
                                <p>
                                    It's universally acknowledged: rewards motivate. When those rewards come in the form of widely accepted Visa cards, be it physical or virtual, the enthusiasm multiplies.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                        <FadeScroll>
                            <HoverCardBorder className='my-3'>
                                <h5 className='fw-bold pt-4 fs-24'>Tailored incentive programs</h5>
                                <p>
                                    No matter what kind of incentive program you’re using them for, our prepaid Visa reward cards can be customized to resonate with any audience.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 py-5'>
                <Row className='justify-content-center'>
                    <Col lg={9}>
                        <PrepaidCardsTabs />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 text-center bg-cream'>
                <Row className='justify-content-center'>
                    <Col xl={5}>
                        <FadeScroll>
                            <h3 className='fs-48'>
                                Personalized rewards for a modern world
                            </h3>
                            <p>
                                In today's age of customization, it's essential to offer rewards that align with individual preferences. Whether it's the tangibility of a physical Visa reward card or the immediacy of a virtual Visa reward account one, our Visa products ensure your gesture of appreciation is always on point.
                            </p>
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>

            <Container fluid className='py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default VisaPrepaidCards;